import {
  AdditionalLoads,
  AnalysisSettings,
  BasicProfile,
  Component,
  ComponentDesign,
  ComponentSide,
  EndConditionSettings,
  FeaturePatternTruss,
  GableSettings,
  HeelReinforcementType,
  JackGirderConnection,
  JackInformation,
  LoadSettings,
  LumberList,
  LumberStockLengthPrices,
  MaterialSettings,
  MemberAnalysisInfo,
  ProfileTruss,
  WebbingInfo,
  ZoneSettings,
} from '@paragon/contract-library';

import { DesignService } from '../connections';

export function adjustSpan(component: Component, componentDesignGuid: string, adjustment: number): Promise<Component> {
  return DesignService.post('componentMacros/adjustSpan', { data: { component, componentDesignGuid, adjustment } });
}

export function editDepth(component: Component, depth: number): Promise<Component> {
  return DesignService.post('componentMacros/editDepth', { data: { component, depth } });
}

export function editOverhangDistance(
  component: ProfileTruss,
  side: ComponentSide,
  distance: number,
): Promise<ProfileTruss> {
  return DesignService.post('componentMacros/editOverhangDistance', { data: { component, side, distance } });
}

export function editZone(componentDesign: ComponentDesign, zoneSettings: ZoneSettings): Promise<FeaturePatternTruss> {
  return DesignService.post('componentMacros/editZone', {
    data: {
      componentDesignGuid: componentDesign.guid,
      component: componentDesign.component,
      zoneSettings,
    },
  });
}

export function editEndCondition(
  componentDesign: ComponentDesign,
  endConditionSettings: EndConditionSettings,
): Promise<FeaturePatternTruss> {
  return DesignService.post(`componentMacros/editEndCondition`, {
    data: {
      componentDesignGuid: componentDesign.guid,
      component: componentDesign.component,
      endConditionSettings,
    },
  });
}

export function editHeelReinforcement(
  componentDesignGuid: string,
  component: ProfileTruss,
  heelReinforcementType: HeelReinforcementType,
  side: ComponentSide,
  distance: number | null,
): Promise<Component> {
  return DesignService.post(`componentMacros/editHeelReinforcement`, {
    data: {
      componentDesignGuid,
      component,
      heelReinforcementType,
      side,
      distance,
    },
  });
}

interface RewebTrussResponse {
  readonly truss: ProfileTruss;
  readonly webbingInfo: WebbingInfo;
  readonly memberAnalysisInfo: MemberAnalysisInfo | null;
}

export function rewebTruss(
  truss: ProfileTruss,
  profile: BasicProfile,
  gableSettings: GableSettings,
  lumberList: LumberList,
  loadSettings: LoadSettings,
  additionalLoads: AdditionalLoads | null,
  jackConnections: readonly JackGirderConnection[],
  jackInformation: { readonly [componentDesignGuid: string]: JackInformation },
  analysisSettings: AnalysisSettings,
  materialSettings: MaterialSettings,
  scarfCutThreshold: number,
  lockedMembers: readonly string[],
  lumberStockLengthPrices: readonly LumberStockLengthPrices[],
  webbingInfo: WebbingInfo | null = null,
) {
  return DesignService.post<RewebTrussResponse>('componentMacros/rewebTruss', {
    data: {
      truss,
      profile,
      gableSettings,
      lumberList,
      loadSettings,
      additionalLoads,
      jackConnections,
      jackInformation,
      analysisSettings,
      materialSettings,
      scarfCutThreshold,
      lockedMembers,
      lumberStockLengthPrices,
      webbingInfo,
    },
  });
}

export function startRewebTruss(truss: ProfileTruss): Promise<BasicProfile> {
  return DesignService.post('componentMacros/startRewebTruss', {
    data: {
      truss,
    },
  });
}
